  <template>
    <div class="p-container">
      <div class="flag-box">
        <img v-if="isSuccess" src="/images/img-2.png" />
        <img v-else src="/images/icon-fail.png" />
      </div>
      <div class="info-container">
        <template v-if="isSuccess">
          <h6>申请已提交！</h6>
          <div class="group-3">
            贷款机构正在审核您提交的申请，1小时内将有机构客户经理联系您复核相关信息，请留意审核来电。
          </div>
        </template>
        <template v-else>
          <div class="group-3">
            <h5>很遗憾，审核没通过！</h5>
            <p>申请以下产品，提高审核通过率!</p>
          </div>
        </template>

      </div>
      <ProductCard v-for="p in items" :key="p.id" :isApply="true" :product="p" @select="selectProduct" />
    </div>
  </template>

<script>
import ProductCard from "./ProductCard.vue";

export default {
  name: "ApplicationResult",
  components: {
    ProductCard
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    isSuccess: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    
  },
  data() {
    return {
     
    };
  },
  watch: {

  },
  methods: {
    selectProduct(row) {
      this.$emit("select", row)
    }
  },
};
</script>

<style lang="less" scoped>
.p-container {
  padding-bottom: 20px;
}

.flag-box {
  margin-top: 50px;
  text-align: center;

  img {
    width: 90px;
    height: 90px;
    background-size: 100% 100%;
  }
}

.info-container {
  margin-top: 36px;
  border-radius: 16px;
  border: 4px solid #b9ddf2;
  background: #b9ddf2;
  box-shadow: 0 4px 13.5px 2px rgba(0, 0, 0, 0.02);
  margin-bottom: 10px;

  h6 {
    color: #254774;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    text-align: center;
    padding: 16px 0;
  }


  .group-3 {
    border-radius: 16px;
    background: #fafdff;
    box-shadow: 0 4px 13.5px 2px rgba(0, 0, 0, 0.02);
    padding: 20px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #254774;
    text-align: justify;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;

    h5 {
      color: #FF6B00;
      font-size: 20px;
      font-weight: 700;
      line-height: 48px;
    }

    p {
      color: #254774;
      font-size: 20px;
      font-weight: 700;
      line-height: 48px;
    }
  }
}
</style>